import React, {ComponentProps} from 'react';
import type {AnchorHTMLAttributes} from 'react';
import {Image} from '@/_application/core/components/ui/image';
import cn from 'classnames';
import Link from '@/_application/core/components/ui/link';
import {useSettings} from '@/framework/settings';
import {getImageAssetUrl} from '@/_application/core/utils/common';

interface LogoProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    logoLink?: string;
    logoProps?: Omit<ComponentProps<typeof Image>, 'src'>;
    logoUrl?: string;
}

const Logo: React.FC<LogoProps> = ({className, logoLink = '/', logoUrl: logoUrlInput, logoProps, ...props}) => {
    const {settings}: any = useSettings();
    const siteTitle = settings?.site_title;
    const logoUrl = getImageAssetUrl('logos/logo.png');
    // Automatically set fill if width/height are not provided
    const shouldUseFill = !logoProps?.width && !logoProps?.height;
    const imageProps = shouldUseFill ? {fill: true, ...logoProps} : logoProps;

    return (
        <Link href={logoLink} className={cn('inline-flex', className)} {...props}>
            <Image src={logoUrlInput ?? logoUrl} alt={siteTitle || 'Kids Plaza'} loading="eager" {...imageProps} />
        </Link>
    );
};

export default Logo;
